<script>
import UserDetailStatisticTile from '@/components/user/tiles/UserDetailStatisticTile.vue';
import UserDetailTableTile from '@/components/user/tiles/UserDetailTableTile.vue';
import utils from '@/utils/common';

// уточнить про продление тарифа

const priceFormatter = new Intl.NumberFormat('ru', { style: 'currency', currency: 'RUB', minimumFractionDigits: 0 });
const formatDate = (date) => utils.convertDateToString(date, 'short');

export default {
  name: 'UserDetailPaymentsTab',
  components: { UserDetailStatisticTile, UserDetailTableTile },
  props: {
    user: Object,
  },
  computed: {
    paymentsConfirmed() {
      return this.user.payments.filter(p => p.status === 'confirmed');
    },

    allPayments() {
      return this.user.payments.filter(p => p.status !== 'test');
    },

    accountBalance() {
      return Math.round(this.user.accountBalance / 100);
    },

    lastPayment() {
      const lastPayment = [...this.paymentsConfirmed]
        .sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime())
        .pop();

      return lastPayment?.amount ? Math.round(lastPayment.amount / 100) : 0;
    },

    paymentsSum() {
      const paymentsSum = this.paymentsConfirmed.reduce((sum, payment) => ({
        ...sum,
        amount: sum?.amount + payment?.amount,
      }), { amount: 0 });

      return Math.round(paymentsSum?.amount / 100);
    },

    paymentStatuses() {
      return {
        confirmed: 'подтвержден',
        cancelled: 'отменён',
        error: 'ошибка',
      };
    },

    paymentTypes() {
      return {
        Payment: 'пополнение баланса',
      };
    },

    paymentsStatistic() {
      return {
        balance:      { label: 'Баланс аккаунта',     icon: 'cash-blue',      value: this.accountBalance,       title: '₽'    }, // eslint-disable-line
        lastPayment:  { label: 'Последний платёж',    icon: 'new-contact',    value: this.lastPayment,     title: '₽'    }, // eslint-disable-line
        paymentsSum:  { label: 'Всего оплачено',      icon: 'arrow-orange',   value: this.paymentsSum,    title: '₽'    }, // eslint-disable-line
        // payedBefore:  { label: 'Продление тарифа',    icon: 'cash-blue',      value: '21.12',   title: '2023' }, // eslint-disable-line
      };
    },

    paymentsHistoryHeaders() {
      return [
        { title: '№ платежа',   width: 10,    component: 'BaseTableCell',   props: (item) => ({ value: item.id }),    required: true  }, // eslint-disable-line
        { title: 'Тип',         width: 13,    component: 'BaseTableCell',   props: (item) => ({ value: item.type, }),                 }, // eslint-disable-line
        { title: 'Дата',        width: 10,    component: 'BaseTableCell',   props: (item) => ({ value: item.createdAt }),             }, // eslint-disable-line
        { title: 'Первод',      width: 10,    component: 'BaseTableCell',   props: (item) => ({ value: item.transaction }),           }, // eslint-disable-line
        { title: 'Сумма',       width: 10,    component: 'BaseTableCell',   props: (item) => ({ value: item.amount, }),                }, // eslint-disable-line
        { title: 'Статус',      width: 10,    component: 'BaseTableCell',   props: (item) => ({ value: item.status, color: this.setStatusCellColor(item.status), isBold: true }),               }, // eslint-disable-line
      ];
    },

    paymentsHistoryItems() {
      return this.allPayments.map(p => ({
        id: p.id,
        type: this.paymentTypes[p['@type']],
        amount: priceFormatter.format(Math.round(p.amount) / 100),
        status: this.paymentStatuses[p.status],
        transaction: 'на свой аккаунт',
        createdAt: formatDate(new Date(p.createdAt)),
      }));
    },
  },
  methods: {
    setStatusCellColor(status) {
      if (status === 'подтвержден' || status === 'подтверждён') {
        return 'rgb(90, 193, 105)';
      }

      if (status === 'ошибка') {
        return 'rgb(241, 114, 117)';
      }

      if (status === 'отменён') {
        return 'rgb(139, 140, 169)';
      }

      return '';
    },
  },
};
</script>

<template lang="pug">
.b-user-detail-payments-tab
  UserDetailStatisticTile(:statistic="paymentsStatistic" label="Платежи" isBorderShown)
  UserDetailTableTile(:headers="paymentsHistoryHeaders" :items="paymentsHistoryItems" label="История платежей")
</template>

<style scoped lang="scss">
.user-detail-payments-tab {
  display: flex;
  flex-direction: column;
  gap: 38px;
}
</style>
